import HeadlessModal from "../HeadlessModal";

export const TrackingModal = ({ order, onClose }) => {
  return (
    <HeadlessModal
      isOpen={!!order}
      onClose={onClose}
      className="max-w-2xl"
      content={
        <div className="flex flex-col divide-y divide-slate-200">
          <div className="flex justify-center	relative p-4">
            <h4 className="text-lg text-gray-800 text-center">Tracking Information</h4>
            <button
              type="button"
              className="absolute right-[1rem] top top-[0.7rem] text-xl opacity-40"
              onClick={onClose}
            >
              &times;
            </button>
          </div>
          <div className="py-4 px-5 text-sm">
            {order?.shipments?.map((shipment) => (
              <div className="mb-2" key={shipment?.id}>
                <h2 className="text-base font-semibold mb-2">Shipment Details</h2>
                <div className="row">
                  <div className="col-xs-12 col-sm-6">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td className="pr-12 pb-2 text-sm">Tracking ID</td>
                          <td className="text-gray-600 text-sm">
                            <a
                              href={shipment.transaction.tracking_url}
                              className="underline text-blue-500"
                            >
                              {shipment.transaction.tracking_number}
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td className="pr-12 pb-2 text-sm">Shipping Method</td>
                          <td className="text-gray-600 text-sm">
                            {shipment.method.provider} {shipment.method.service}
                          </td>
                        </tr>

                        <tr>
                          <td className="pr-12 pb-2 text-sm">Address</td>
                          <td className="text-gray-600 text-sm">
                            <p>{shipment.location_name}</p>
                            <p>
                              {shipment.street1} {shipment.street2}
                            </p>
                            <p>
                              {shipment.city}, {shipment.state} {shipment.postal_code}{" "}
                              {shipment.country.name}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ))}

            <div className="flex justify-evenly w-full">
              <button className="clear-button capitalize" onClick={onClose}>
                OK
              </button>
            </div>
          </div>
        </div>
      }
    />
  );
};
